import { MapPin } from "lucide-react";
import { motion } from "framer-motion";
import BackgroundPattern from "@/components/BackgroundPattern";

const areas = [
  "Albuquerque",
  "Rio Rancho",
  "Corrales",
  "Los Lunas",
  "Bernalillo",
  "Santa Fe",
  "Belen",
  "Edgewood",
  "Moriarty",
  "Placitas",
  "Tijeras",
  "Cedar Crest",
  "Los Ranchos",
  "South Valley",
  "North Valley",
  "Bosque Farms",
  "Peralta",
  "Sandia Park",
  "East Mountains",
  "Valencia County",
];

const ServiceAreasSection = () => (
  <section className="py-16 md:py-20 bg-section-light relative" aria-label="Service areas in New Mexico">
    <BackgroundPattern variant="grid" />
    <div className="container mx-auto max-w-5xl px-4 relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-center mb-10"
      >
        <p className="text-sm font-bold uppercase tracking-widest text-primary mb-3">Service Areas</p>
        <h2 className="text-3xl md:text-4xl font-black text-foreground">
          Proudly Serving Albuquerque & All of Central New Mexico
        </h2>
        <p className="text-muted-foreground mt-3 max-w-2xl mx-auto">
          From roof replacements in Rio Rancho to solar installations in Santa Fe — our licensed team covers the entire
          metro area and beyond.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="flex flex-wrap justify-center gap-3"
      >
        {areas.map((area) => (
          <span
            key={area}
            className="inline-flex items-center gap-1.5 bg-card border rounded-full px-4 py-2 text-sm font-medium text-foreground shadow-sm"
          >
            <MapPin className="h-3.5 w-3.5 text-primary flex-shrink-0" aria-hidden="true" />
            {area}, NM
          </span>
        ))}
      </motion.div>

      <p className="text-center text-sm text-muted-foreground mt-6">
        Don't see your area?{" "}
        <a href="tel:5056048536" className="text-primary font-semibold hover:underline">
          Call (505) 604-8536
        </a>{" "}
        — we likely serve your neighborhood too.
      </p>
    </div>
  </section>
);

export default ServiceAreasSection;
